import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalInstance } from "./_auth/msalInstance";
import SystemState from "./_context/systemState"; 
import "./HomeSAP.css";
import "./index.css";
import "./Bienvenida.css"

ReactDOM.createRoot(document.getElementById("root")).render(
  <MsalProvider instance={msalInstance}>
    <SystemState>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SystemState>
  </MsalProvider>
);
